export type FormulusOptions = Partial<{
  autoAttach: boolean
  formAttribute: string
  noValidateAttribute: string
  errorClass: string
  errorLabelClass: string
  translate: (input: HTMLInputElement) => string,
  errorDivFactory: () => HTMLElement
}>


const defaultTranslate = function(input: HTMLInputElement) {
  // const potentials = ["valueMissing", "typeMismatch", "patternMismatch", "tooShort", "tooLong", "rangeUnderflow", "rangeOverflow", "stepMismatch", "badInput", "customError"]
  // const firstInvalidKey = potentials.find(key => input.validity[key])
  // if (firstInvalidKey) {
  //   // Translation Code js.
  // }
  // console.log(firstInvalidKey)
  return input.validationMessage
}

const defaultFactory = function(input: HTMLInputElement) {
  const invalidFeedbackDiv = document.createElement('div')
  invalidFeedbackDiv.classList.add("invalid-feedback")
  if (input.nodeName === "INPUT") {
    input.parentNode?.insertBefore(invalidFeedbackDiv, input.lastChild)
  } else if (input.nodeName === "SELECT") {
    input.parentNode?.appendChild(invalidFeedbackDiv)
  }
  return invalidFeedbackDiv
}

// <div class="invalid-feedback"></div> statt label

export class FormulusConfig {
  public autoAttach: boolean = this.options.autoAttach ?? false;
  public formAttribute: string = this.options.formAttribute ?? "formulus";
  public noValidateAttribute: string = this.options.noValidateAttribute ?? "novalidate";
  public errorClass: string = this.options.errorClass ?? "is-invalid";
  public errorDivFactory: (input: HTMLInputElement) => HTMLElement = this.options.errorDivFactory ?? defaultFactory;
  public translate: (input: HTMLInputElement) => string = this.options.translate ?? defaultTranslate;
      // const invalidFeedbackDiv = document.createElement('div')
  // public errorLabelClass: string = this.options.errorLabelClass ?? "error-label";

  constructor(private options: FormulusOptions = {}) {

  }
}
